import { Box, Button, Divider, Dropdown, Gleam, Icon, Legend, TextButton } from '@zillow/constellation-10';
import { IconFilterFilled, IconFilterOutline } from '@zillow/constellation-icons';
import { useContext, useState } from 'react';
import { ReadRepliedStatus } from '../../types/GraphqlTypes';
import useInboxRouterHelper from '../../hooks/useInboxRouterHelper';
import { InboxPageContext } from '../../contexts/InboxPageContextProvider';
import PropertySearchBar from './components/PropertySearchBar';
import StatusSelector from './components/StatusSelector';
import useDevices from '../../hooks/useDevices';

export default function FiltersSelector() {
  const { isMobileView } = useDevices();
  const { changeFiltersOrFolders } = useInboxRouterHelper();
  const { folder, listingAlias, isByProperty, readRepliedStatus, renterProgressStatus } = useContext(InboxPageContext);
  const [isOpen, setIsOpen] = useState(false);

  const isUnreadActive = readRepliedStatus === ReadRepliedStatus.Unread;
  const isNotRepliedToActive = readRepliedStatus === ReadRepliedStatus.NotRepliedTo;
  const appliedFiltersCount = Number(isUnreadActive || isNotRepliedToActive) + Number(isByProperty);
  const filtersCountDisplay = appliedFiltersCount ? ` (${appliedFiltersCount})` : '';

  const handleClearStatusFilter = () => {
    changeFiltersOrFolders({
      folder,
      readRepliedStatus: ReadRepliedStatus.ShowAll,
      renterProgressStatus,
      byProperty: isByProperty,
      listingAlias: listingAlias || '',
    });
  };

  return (
    <Dropdown
      open={isOpen}
      onOpenChange={setIsOpen}
      placement="bottom-end"
      header={
        <Dropdown.Heading level={4} css={{ textTransform: 'capitalize' }}>
          <Icon>
            <IconFilterFilled />
          </Icon>
          Filter by
        </Dropdown.Heading>
      }
      body={
        <>
          <PropertySearchBar />

          <Divider css={{ marginBlock: 'loose' }} />

          <Box css={{ display: 'flex', justifyContent: 'space-between' }}>
            <Legend>Status</Legend>
            <TextButton
              textStyle="body-sm"
              disabled={readRepliedStatus === ReadRepliedStatus.ShowAll}
              onClick={handleClearStatusFilter}
            >
              Clear
            </TextButton>
          </Box>

          <StatusSelector />

          <Dropdown.Close css={{ marginTop: 'tighter' }}>
            <TextButton>Close</TextButton>
          </Dropdown.Close>
        </>
      }
      trigger={
        !isMobileView ? (
          <Button
            emphasis="outlined"
            icon={<IconFilterOutline />}
            iconPosition="start"
            size="md"
            tone="brand"
            css={{
              width: 'max-content',
              ...(appliedFiltersCount && {
                backgroundColor: 'Button.outlined.neutral.bg.selected',
                boxShadow: 'inset 0 0 0 var(--border-widths--toggle-button-selected) var(--shadow-color)',
              }),
            }}
          >
            Filters{filtersCountDisplay}
          </Button>
        ) : (
          <Gleam.Root>
            <Icon aria-label="Filters" size="lg" css={{ color: 'brand' }}>
              <IconFilterOutline />
            </Icon>
            {appliedFiltersCount > 0 && <Gleam.Dot count={appliedFiltersCount} tone="default" />}
          </Gleam.Root>
        )
      }
      css={{
        minWidth: { base: '330px', md: '360px' },
      }}
    />
  );
}
